module.exports = __webpack_public_path__ + "static/media/guitar-electric.2311a74d.svg";